/* eslint-disable no-unused-vars */
/* eslint-disable semi */
import axios from 'axios';
import {
  getUrlKey
} from '@/util/util';
import qs from 'qs';

// 请求超时时间
axios.defaults.timeout = 10000;
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// axios.defaults.withCredentials = true
// POST传参序列化

axios.interceptors.request.use((config) => {
  config.headers = {
    'platform': 2,
    token: getUrlKey('token')
    // 'token': 'rig64T10cfFpqj6ZnVh4LrDVR9mEv2aV'
  };
  console.log(config.headers)
  return config;
}, (error) => {
  this.$toast.center('错误的传参');
  return Promise.reject(error);
});
// 返回状态判断
axios.interceptors.response.use((res) => {
  if (res.status === 200) {
    return Promise.resolve(res);
  } else {
    return Promise.reject(res);
  }
}, (error) => {
  this.$toast.center('网络异常')
  return Promise.reject(error);
});
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get (url, params) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post (url, params) {
  console.log(url)
  console.log(params)
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}



// WEBPACK FOOTER //
// ./src/request/axios.js